export class ScanJob {
    'jobExecutionDetails';
    'resourceDetails';
    'scanType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobExecutionDetails",
            "baseName": "jobExecutionDetails",
            "type": "JobExecutionDetails",
            "format": ""
        },
        {
            "name": "resourceDetails",
            "baseName": "resourceDetails",
            "type": "ResourceDetails",
            "format": ""
        },
        {
            "name": "scanType",
            "baseName": "scanType",
            "type": "ScanJobType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ScanJob.attributeTypeMap;
    }
    constructor() {
    }
}
